import { useMutation } from "react-query";
import http from "infra/http";

function useDesvincularUnidadeGrupo(id: string) {
  return useMutation(
    ({unidadeId}: {unidadeId: string}) => {
      return http.put(`/v1/grupo-unidade/desvincular/${id}`, {unidadeId});
    },
    { retry: false }
  );
}

export default useDesvincularUnidadeGrupo;
